import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const trialDoiApi = {
    getTrialDoiByTrialId: (trialId: number): Observable<Dtos.GetTrialDoiByTrialIdResponse> => {
        //Create the request.
        let request: Dtos.GetTrialDoiByTrialId = new Dtos.GetTrialDoiByTrialId();
        request.trialId = trialId;

        //Send request.
        const response: Promise<Dtos.GetTrialDoiByTrialIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getTrialDoiById: (id: number): Observable<Dtos.GetTrialDoiByIdResponse> => {
        //Create the request.
        let request: Dtos.GetTrialDoiById = new Dtos.GetTrialDoiById();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.GetTrialDoiByIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    setTrialDoi: (trialDoi: Dtos.TrialDoi): Observable<Dtos.SetTrialDoiResponse> => {

        let request: Dtos.SetTrialDoi = new Dtos.SetTrialDoi();

        request.trialDoi = trialDoi;

        // send request
        const response: Promise<Dtos.SetTrialDoiResponse> = client.post(request);

        return Observable.from(response);
    },
    createTrialDoi: (trialId: number): Observable<Dtos.CreateTrialDoiResponse> => {
        //Create the request.
        let request: Dtos.CreateTrialDoi = new Dtos.CreateTrialDoi();

        request.trialId = trialId;

        //Send request.
        const response: Promise<Dtos.CreateTrialDoiResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    validateTrialDoi: (trialDoi: Dtos.TrialDoi): Observable<Dtos.ValidateTrialDoiResponse> => {

        let request: Dtos.ValidateTrialDoi = new Dtos.ValidateTrialDoi();

        request.trialDoi = trialDoi;

        // send request
        const response: Promise<Dtos.ValidateTrialDoiResponse> = client.post(request);

        return Observable.from(response);
    },
}